import { useState } from "react";
import { BarChart3 } from "lucide-react";
import { PROFILE } from "../../data/content";
import { Insights } from "./Insights";

export const Footer = () => {
  const [insightsOpen, setInsightsOpen] = useState(false);
  const showInsights = typeof window !== "undefined" && new URLSearchParams(window.location.search).has("insights");
  const go = (e, href) => { e.preventDefault(); document.querySelector(href)?.scrollIntoView({ behavior: "smooth" }); };
  return (
    <footer className="footer dark-zone" aria-label="Site footer">
      <div className="footer-inner">
        <a href="#about" className="footer-logo" onClick={(e) => go(e, "#about")} aria-label="Augustus Emenogu home">
          <div style={{ width: 28, height: 28, background: "linear-gradient(135deg,var(--primary),var(--accent-teal))",
            borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center",
            fontFamily: "var(--font-display)", fontSize: "0.75rem", fontWeight: 700, color: "var(--on-accent)" }} aria-hidden="true">AE</div>
          Augustus Emenogu
        </a>
        <ul className="footer-links" role="list">
          <li><a href="#about" onClick={(e) => go(e, "#about")}>About</a></li>
          <li><a href="#services" onClick={(e) => go(e, "#services")}>Services</a></li>
          <li><a href="#portfolio" onClick={(e) => go(e, "#portfolio")}>Portfolio</a></li>
          <li><a href="#training" onClick={(e) => go(e, "#training")}>Training</a></li>
          <li><a href="#volunteering" onClick={(e) => go(e, "#volunteering")}>Volunteering</a></li>
          <li><a href="#contact" onClick={(e) => go(e, "#contact")}>Contact</a></li>
          {showInsights && (
            <li>
              <button className="footer-insights" onClick={() => setInsightsOpen(true)} data-testid="footer-insights-btn">
                <BarChart3 size={13} /> Insights
              </button>
            </li>
          )}
        </ul>
        <div className="footer-copy">&copy; {new Date().getFullYear()} {PROFILE.name}. All rights reserved.</div>
      </div>
      <Insights open={insightsOpen} onClose={() => setInsightsOpen(false)} />
    </footer>
  );
};
